import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName } from '../utils';

enum KnowledgeBaseOrderItem {
  code = '1',
  name = '2',
}

const nameConfig = {
  code: new Map([
    [Locale.ja, 'コード'],
    [Locale.en, 'Code'],
  ]),
  name: new Map([
    [Locale.ja, '名称'],
    [Locale.en, 'Name'],
  ]),
};

const toDisplay = enumToName(KnowledgeBaseOrderItem, nameConfig);
const toDisplayWithPrefix = enumToName(KnowledgeBaseOrderItem, nameConfig, { prefix: true });

export const knowledgeBaseOrderItem = {
  enum: KnowledgeBaseOrderItem,
  nameConfig,
  toDisplay,
  toDisplayWithPrefix,
};
export type { KnowledgeBaseOrderItem };
